module.exports = __webpack_public_path__ + "media/games-18.5967ca79.mp4";